import { render, staticRenderFns } from "./WsRequestExamsTable.vue?vue&type=template&id=728cf8eb"
import script from "./WsRequestExamsTable.vue?vue&type=script&lang=js"
export * from "./WsRequestExamsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports